import route from '@router/route';
import { slugify } from '@/helpers/string';

/**
 * Helper function to get a course page link.
 */
export function getCourseLink(id: number, courseName: string, isDashboard?: boolean | null | undefined) {
    // This queryString is needed for the course join click tracking if the user came to course page from the dashboard widget
    const queryString = isDashboard ? '?dashboard=1' : '';
    return (
        route('course.show', {
            id,
            courseName: slugify(courseName),
        }) + queryString
    );
}

/**
 * Helper function to get a university page link.
 */
export function getUniLink(id: number, uniName: string) {
    return route('university.show', {
        id,
        uniName: slugify(uniName),
    });
}

export function getDocumentLink(id: number, name: string): string {
    return route('document.show', {
        // remove file extension
        slug: slugify(name.substring(0, name.lastIndexOf('.'))),
        id,
    });
}

/**
 * Helper function to get a flashcard page link.
 */
export function getFlashcardLink(id: number, name: string) {
    return route('flashcards.slug.id', {
        slug: slugify(name),
        id,
    });
}

export function getStudyMaterialLink(id: number, name: string, type = 'document' as 'document' | 'flashcard'): string {
    return type === 'document' ? getDocumentLink(id, name) : getFlashcardLink(id, name);
}

/**
 * Helper function to get a user page link.
 */
export function getUserLink(id: number, name: string) {
    return route('profile.show', {
        id,
        slug: slugify(name),
    });
}

export function getGroupLink(id: number, name: string) {
    return route('groups.show', {
        id,
        groupName: slugify(name),
    });
}
